import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import EventDetails from "./details/List";
import {NavLink, Route} from "react-router-dom";
import EventMedia from "./media/List";
import {EVENT_ACTIONS} from "../../../redux/events/actions";
import {selectActiveEvent} from "../../../redux/events/selectors";
import Vouchers from "./vouchers/Vouchers";
import Parking from "./parking/List";
import Catering from "./catering/List";
import CateringCreate from "./catering/Create";
import CateringEdit from "./catering/Edit";
import DefaultAccess from "./access/List";
import SafetyQuestions from "./safetyQuestions/List";
import EmailTemplates from "./emailTemplates/List";
import CrewMaterials from "./crewMaterials/List";
import ParkingsCreate from "./parking/Create";
import {EventMaterialOverview} from "./materials/EventMaterialOverview";
import FrequentPassageStickerTypesList from "./frequentPassageStickerTypes/FrequentPassageStickerTypesList";
import FrequentPassageStickerTypesCreate from "./frequentPassageStickerTypes/FrequentPassageStickerTypesCreate";

class _EventsDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eventId: props.match.params.id
        };

        //this._handleCreate = this._handleCreate.bind(this);
    }

    static propTypes = {
        loadEvent: PropTypes.func,
        event: PropTypes.object,
        match: PropTypes.object
    };

    UNSAFE_componentWillMount() {
        this.props.loadEvent(this.state.eventId);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
    }

    render() {
        const {eventId} = this.state;
        const {event} = this.props;

        return [
            <AdminSubHeader title={event.name} key="subheader" breadcrumbs={[]}/>,
            <div className="m-content" key="content">
                <div className="m-portlet m-portlet--tabs">
                    <div className="m-portlet__head">
                        <div className="m-portlet__head-tools">
                            <ul
                                className="nav nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x"
                                role="tablist"
                            >
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        exact
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId}
                                    >
                                        <i className="la la-info-circle"/> Details
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/media"}
                                    >
                                        <i className="la la-hdd-o"/> Media
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/safety-questions"}
                                    >
                                        <i className="la la-life-saver"/> Safety
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/catering"}
                                    >
                                        <i className="la la-cutlery"/> Catering
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/parking"}
                                    >
                                        <i className="la la-automobile"/> Parking
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/frequent-passage-sticker-types"}
                                    >
                                        <i className="la la-truck"/> Frequent Passage
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/materials"}
                                    >
                                        <i className="icon-gator"/> Materials
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/vouchers"}
                                    >
                                        <i className="la la-file-pdf-o"/> Vouchers
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/access"}
                                    >
                                        <i className="la la-street-view"/> Access
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/crew-materials"}
                                    >
                                        <i className="icon-shirt"/> Crew Materials
                                    </NavLink>
                                </li>
                                <li className="nav-item m-tabs__item">
                                    <NavLink
                                        activeClassName="active"
                                        className="nav-link m-tabs__link"
                                        to={"/admin/events/" + eventId + "/email-templates"}
                                    >
                                        <i className="la la-envelope"/> Emails
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                {this.props.event &&
                    this.props.event.id && [
                        <Route
                            key="details"
                            exact
                            path="/admin/events/:id"
                            render={routeProps => (
                                <EventDetails {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            key="media"
                            exact
                            path="/admin/events/:id/media"
                            render={routeProps => (
                                <EventMedia {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            key="vouchers"
                            path="/admin/events/:id/vouchers"
                            render={routeProps => <Vouchers {...routeProps} event={event}/>}
                        />,
                        <Route
                            exact
                            key="parking"
                            path="/admin/events/:id/parking"
                            render={routeProps => <Parking {...routeProps} event={event}/>}
                        />,
                        <Route
                            exact
                            key="parkingCreate"
                            path="/admin/events/:id/parking/create"
                            render={routeProps => (
                                <ParkingsCreate {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="parkingEdit"
                            path="/admin/events/:id/parking/:parkingId/edit"
                            render={routeProps => (
                                <ParkingsCreate {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="frequentPassageStickerTypes"
                            path="/admin/events/:id/frequent-passage-sticker-types"
                            render={routeProps => (
                                <FrequentPassageStickerTypesList {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="frequentPassageStickerTypesCreate"
                            path="/admin/events/:id/frequent-passage-sticker-types/create"
                            render={routeProps => (
                                <FrequentPassageStickerTypesCreate {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="frequentPassageStickerTypesEdit"
                            path="/admin/events/:id/frequent-passage-sticker-types/:frequentPassageStickerTypesId/edit"
                            render={routeProps => (
                                <FrequentPassageStickerTypesCreate {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="access"
                            path="/admin/events/:id/access"
                            render={routeProps => (
                                <DefaultAccess {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="catering"
                            path="/admin/events/:id/catering"
                            render={routeProps => <Catering {...routeProps} event={event}/>}
                        />,
                        <Route
                            exact
                            key="cateringCreate"
                            path="/admin/events/:id/catering/create"
                            render={routeProps => (
                                <CateringCreate {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="cateringEdit"
                            path="/admin/events/:id/catering/:cateringId/edit"
                            render={routeProps => (
                                <CateringEdit {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            key="materials"
                            path="/admin/events/:id/materials"
                            render={routeProps => (
                                <EventMaterialOverview {...routeProps} event={event}/>
                            )}
                        />,
                        // <Route
                        //   exact
                        //   key="materialsDetails"
                        //   path="/admin/events/:id/material-requests/:materialId"
                        //   render={routeProps => <EventMaterialOverview {...routeProps} event={event} />}
                        // />,
                        <Route
                            exact
                            key="safetyQuestions"
                            path="/admin/events/:id/safety-questions"
                            render={routeProps => (
                                <SafetyQuestions {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="safetyQuestionsEdit"
                            path="/admin/events/:id/safety-questions/:safetyQuestionId/edit"
                            render={routeProps => (
                                <SafetyQuestions {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="emailTemplates"
                            path="/admin/events/:id/email-templates"
                            render={routeProps => (
                                <EmailTemplates {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="emailTemplatesEdit"
                            path="/admin/events/:id/email-templates/:emailTemplateId/edit"
                            render={routeProps => (
                                <EmailTemplates {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="crewmaterials"
                            path="/admin/events/:id/crew-materials"
                            render={routeProps => (
                                <CrewMaterials {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="crewmaterialsdetail"
                            path="/admin/events/:id/crew-materials/:materialId"
                            render={routeProps => (
                                <CrewMaterials {...routeProps} event={event}/>
                            )}
                        />,
                        <Route
                            exact
                            key="crewmaterialseditTemplate"
                            path="/admin/events/:id/crew-materials/:materialId/template/:templateId/edit"
                            render={routeProps => (
                                <CrewMaterials {...routeProps} event={event}/>
                            )}
                        />
                    ]}
            </div>
        ];
    }
}

const mapDispatchToProps = dispatch => ({
    loadEvent: id => dispatch(EVENT_ACTIONS.loadRequest(id))
});

const mapStateToProps = function (state) {
    return {
        event: selectActiveEvent(state)
    };
};

const EventsDetail = connect(
    mapStateToProps,
    mapDispatchToProps
)(_EventsDetail);

export default EventsDetail;
